import React, { useState } from "react";
import { connect } from "react-redux";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import MailLockIcon from '@mui/icons-material/MailLock';
import Typography from "@mui/material/Typography";

import { sendPasswordResetEmail } from "../../actions/authActions";
import SendEmailForm from "./SendEmailForm";

const PasswordReset = (props) => {
    const [emailSent, setEmailSent] = useState(false)

    const sendEmail = (formValues) => {
        props.sendPasswordResetEmail(formValues);
        setEmailSent(true);
    }

    const renderSendEmail = () => {
        return (
            <React.Fragment>
                <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                    <MailLockIcon />
                </Avatar>
                <Typography variant="h5">
                    Reset Password
                </Typography>
                <Box sx={{ mt: 5, maxWidth: 300 }}>
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                        Enter your email and we will send you a link to reset your password
                    </Typography>
                    <SendEmailForm onSubmit={sendEmail} />
                </Box>
            </React.Fragment>
        )
    }

    const renderEmailSent = () => {
        return (
            <React.Fragment>
                <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                    <MailLockIcon />
                </Avatar>
                <Typography variant="h5">
                    Email sent
                </Typography>
                <Box sx={{ mt: 2, maxWidth: 300 }}>
                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                        Check your email and open the link we sent to continue
                    </Typography>
                </Box>
            </React.Fragment>
        )
    }

    return (
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {!emailSent ? renderSendEmail() : renderEmailSent()}
        </Box>
    )
}

export default connect(null, { sendPasswordResetEmail })(PasswordReset)